// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/sass/master.scss
// module id = 29
// module chunks = 0